import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface ICustomerProps {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
  address?: {
    street?: string | null;
    city?: string | null;
    state?: string | null;
    postal_code?: string | null;
    country?: string | null;
  };
}

const initialState: ICustomerProps = {
  firstName: null,
  lastName: null,
  email: null,
  phone: null,
  address: {
    street: null,
    city: null,
    state: null,
    postal_code: null,
    country: null,
  },
};

const useCustomerStore = create(
  persist<ICustomerProps>(() => initialState, {
    name: "customer-store",
    storage: createJSONStorage(() => localStorage),
  })
);
export default useCustomerStore;
